export default "__VITE_PUBLIC_ASSET__0705df0a__"